module.exports = __webpack_public_path__ + "20-o1.gif?ee598af48cccfba27baf7392c2f64845";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/20-o1.gif
// module id = 640
// module chunks = 0